import { Directive, AfterViewInit, ElementRef, Input, inject } from '@angular/core';

@Directive({ selector: '[appAutofocus]' })
export class AutofocusDirective implements AfterViewInit {
  private element = inject(ElementRef);

  @Input()
  public enableAutofocus = true;

  public ngAfterViewInit(): void {
    if (this.enableAutofocus) {
      setTimeout(() => {
        if (this.element.nativeElement.nodeName === 'APP-MKDE-DATEPICKER') {
          this.element.nativeElement.children[0].focus();
        } else {
          this.element.nativeElement.focus();
        }
      }, 0);
    }
  }
}
